export const ADD_TRANSAJCTION = 'ADD_TRANSAJCTION';
export const GET_TRANSAJCTION = 'GET_TRANSAJCTION';
export const GET_CITY = 'GET_CITY';
export const CHECK_PASSWORD_TRAN = 'CHECK_PASSWORD_TRAN';
export const CHECK_PASSWORD_TRAN_FALSE = 'CHECK_PASSWORD_TRAN_FALSE';
export const GET_LEADER_DATA = 'GET_LEADER_DATA';
